
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { AuthUser } from "./types";
import { useAuthFunctions } from "./useAuthFunctions";

export const useAuthState = () => {
  const [user, setUser] = useState<AuthUser | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  
  const authFunctions = useAuthFunctions(setUser, setIsLoading);
  
  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event, session) => {
        if (session?.user) {
          setUser({
            id: session.user.id,
            email: session.user.email || "",
            name: session.user.user_metadata.name || session.user.email?.split("@")[0] || "",
            companyName: session.user.user_metadata.companyName || "",
          });
          
          authFunctions.fetchUserRoles(session.user.id);
        } else {
          setUser(null);
        }
        setIsLoading(false);
      }
    );

    checkUser();

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  const checkUser = async () => {
    const { data: { session } } = await supabase.auth.getSession();
    if (session?.user) {
      setUser({
        id: session.user.id,
        email: session.user.email || "",
        name: session.user.user_metadata.name || session.user.email?.split("@")[0] || "",
        companyName: session.user.user_metadata.companyName || "",
      });
      
      authFunctions.fetchUserRoles(session.user.id);
    }
    setIsLoading(false);
  };

  return {
    user,
    setUser,
    isLoading,
    setIsLoading,
    ...authFunctions
  };
};
